import { render, staticRenderFns } from "./fixed-price-pack-dialog.vue?vue&type=template&id=6237d982&scoped=true"
import script from "./fixed-price-pack-dialog.vue?vue&type=script&lang=js"
export * from "./fixed-price-pack-dialog.vue?vue&type=script&lang=js"
import style0 from "./fixed-price-pack-dialog.vue?vue&type=style&index=0&id=6237d982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237d982",
  null
  
)

export default component.exports